import { render, staticRenderFns } from "./GoFeedback.vue?vue&type=template&id=9824ea6a&scoped=true&"
import script from "./GoFeedback.vue?vue&type=script&lang=js&"
export * from "./GoFeedback.vue?vue&type=script&lang=js&"
import style0 from "./GoFeedback.vue?vue&type=style&index=0&id=9824ea6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9824ea6a",
  null
  
)

export default component.exports